.delaySymbol {
  svg {
    display: inline;
    vertical-align: middle;
    font-size: 1.5rem;
    color: $ontime-delay;
    margin: 0 auto;
  }
}
